<template lang="pug">
.dropdown-menu(
	:class='{ opened : isOpen }'
	@click='isOpen = true'
	@mouseleave='isOpen = false'
)
	p.label {{ label }}
	.arrow
	.options
		.option(
			v-for='option in options'
			:class='{ active : value == option.value }'
			@click.stop='onSelect( option )'
		)
			p {{ option.label }}
</template>

<script>
export default {
  name  : 'dropdown-select',
  props : {
    value   : String,
    label   : String,
    options : Array,
  },
  data() {
    return {
      isOpen : false,
    };
  },

  mounted() {
    if ( !this.value ) this.$emit( 'change', this.options[0].value );
  },

  methods : {
    onSelect( option ) {
      this.$emit( 'change', option.value );
    }
  }
};
</script>

<style lang="scss" scoped>
.dropdown-menu {
	position: relative;
	display: inline-flex;
	align-items: center;
	padding: 10px 10px;
	cursor: pointer;
	color: #646971;
	transition: all .2s ease;
	padding-right: 25px;

	&.hidden {
		display : none;
	}

	.label {
		color : $primary;
		text-transform: uppercase;
		font-size: 14px;
		font-weight: 600;
	}

	&::after {
		border-color: $primary;
	}

	&.opened {

		&::after {
			transform: translate(-100%,-34%) rotate(225deg);
		}

		.arrow {
			opacity: 1;
			pointer-events: all;
		}

		.options {
			opacity: 1;
			pointer-events: all;
		}
	}

	&:after {
		position: absolute;
		width: 4px;
		height: 4px;
		top: 50%;
		right: 0;
		border-right: #4a4a4a solid 2px;
		border-bottom: #4a4a4a solid 2px;
		transform: translate(-100%,-66%) rotate(45deg);
		transition: all .2s ease;
		content: ' ';
	}

	.arrow {
		position: absolute;
		height: 30px;
		width: 100%;
		min-width: 250px;
		overflow: hidden;
		top: 100%;
		left: 50%;
		transform: translateX(-50%);
		z-index: 10;
		opacity: 0;
		transition: opacity 0.2s ease;
		pointer-events: none;

		&::before {
			content: '';
			height: 30px;
			width: 30px;
			background: white;
			box-shadow: $floatingObject;
			position: absolute;
			top: 100%;
			left: 50%;
			transform: translate(-50%,-50%) rotate(45deg);
		}
	}

	.options {
		opacity: 0;
		padding: 5px;
		transition: all .2s ease;
		pointer-events: none;
		position: absolute;
		box-shadow: $floatingObject;
		top: calc(100% + 30px);
		left: 50%;
		min-width: 200px;
		border-radius: 10px;
		transform: translateX(-50%);
		background-color: white;
		white-space: nowrap;
		z-index: 1;
		max-height: 500px;
		overflow: auto;

		&.left {
			left : 0%;
			transform: translateX(0%);
		}

		.option {
			display: flex;
			padding: 5px 10px 5px 35px;
			position: relative;

			&::after {
				content: " ";
				position: absolute;
				top: 50%;
				left: 10px;
				height: 12px;
				width: 12px;
				border: 2px solid $primary;
				transform: translateY(-50%);
				border-radius: 3px;
			}

			&.active {

				&::after {
					background-color: $primary;
				}

				&::before {
					content: " ";
					height: 4px;
					width: 8px;
					position: absolute;
					top: 18px;
					left: 12px;
					border-left: 3px solid white;
					border-bottom: 3px solid white;
					transform: translateY(calc(-50% - 3px)) rotate(-45deg);
					z-index: 10;
				}
			}
		}
	}
}
</style>
